// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import RateSvg from '@rsuite/icon-font/lib/application/Rate';
var Rate = createSvgIcon({
  as: RateSvg,
  ariaLabel: 'rate',
  category: 'application',
  displayName: 'Rate'
});
export default Rate;